module.exports = __webpack_public_path__ + "static/hybrid-4baa04ab640ea92e914379d9e0afd088.png";